(function () {
    "use strict";

    angular.module("app").controller("AllScreeningsController", AllScreeningsController);

    AllScreeningsController.$inject = ["controllerDecorator", "infiniteScrollDataSourceFactory", "enumService", "screeningApi", "habilDate",];
    function AllScreeningsController(controllerDecorator, infiniteScrollDataSourceFactory, enumService, screeningApi, habilDate) {
        const vm = Object.assign(this, {
            getRequestUrl,
            getItemStyle,
            getClearanceStyle,
            exportToExcel,
        });
        controllerDecorator.Decorate(vm, ["navigation"]);

        vm.screeningTypes = enumService.ScreeningTypeCode;

        vm.DataSource = null;

        activate();

        function activate() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(screeningApi.Search, (v) => vm.isLoadingRequests = v);

            const filter = vm.DataSource.GetFilter();
            if (!filter.ScreeningTermFilter)
                filter.ScreeningTermFilter = "Any";

            const pageAndSort = vm.DataSource.GetPageAndSort();

            if (pageAndSort.SortBy.length > 0) {
                vm.sortType = pageAndSort.SortBy[0].Name;
                vm.sortReverse = pageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "RequestDate";
                vm.sortReverse = false;
            }

            vm.SetLoadingState(false);
        }

        function getRequestUrl(requestItem) {
            if (requestItem.ScreeningTypeCode === enumService.ScreeningTypeCode.FVM) {
                return `${vm.Settings.applicationPath}Screenings/FVMRequest/?screeningId=${requestItem.ScreeningPublicId}`;
            }
            else {
                return `${vm.Settings.applicationPath}Screenings/IVMRequest/?requestId=${requestItem.RequestPublicId}`;
            }
        }

        function getItemStyle(requestItem) {
            if (requestItem.ScreeningOutOfTerm)
                return "screeningOutOfTimeLimit";
            if (![enumService.ScreeningTypeCode.FVM, enumService.ScreeningTypeCode.IVM].includes(requestItem.ScreeningTypeCode))
                return "foreign";

            return "";
        }

        function getClearanceStyle(clearanceExpiration) {
            if (!clearanceExpiration)
                return "";

            const today = habilDate.GetDateOnly(new Date());
            const warningDate = habilDate.AddMonths(today, 12);
            const expirationDate = habilDate.GetDateOnly(clearanceExpiration);

            if (expirationDate.valueOf() < today.valueOf())
                return "btn-danger";
            if (expirationDate.valueOf() < warningDate.valueOf())
                return "btn-warning";
            return "btn-success";
        }

        function exportToExcel() {
            vm.SetLoadingState(true);

            screeningApi.Search(
                { Filter: vm.DataSource.GetFilter() },
                angular.noop,
                vm.ShowError,
                () => vm.SetLoadingState(false),
                {
                    // Trigger content negotiation
                    headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
                    responseType: "arraybuffer",
                }
            );
        }
    }
})();
